import { useEffect, useState } from 'react';
import { softphone } from './streams';
import { useSoftphone } from './useSoftphone';

function Timer({ since }: { since?: number }) {
  const [, tick] = useState(0);
  useEffect(() => { const id = setInterval(() => tick((n) => n + 1), 1000); return () => clearInterval(id); }, []);
  if (!since) return null;
  const s = Math.floor((Date.now() - since) / 1000);
  return <span className="timer">{String(Math.floor(s / 60)).padStart(2, '0')}:{String(s % 60).padStart(2, '0')}</span>;
}

export function SoftphonePanel({ onContact }: { onContact?: (attrs: Record<string, string>, phone: string) => void }) {
  const { agentStatus, agentName, call } = useSoftphone();
  const [dial, setDial] = useState('');

  useEffect(() => {
    if (call && (call.state === 'incoming' || call.state === 'connecting')) onContact?.(call.attributes, call.phoneNumber);
  }, [call?.contactId, call?.state]);

  return (
    <aside className="softphone">
      <header>
        <strong>{agentName || 'Not signed in'}</strong>
        <span className={`status status-${agentStatus}`}>{agentStatus}</span>
      </header>
      <div className="row">
        <button onClick={() => softphone.setAvailable()} disabled={agentStatus === 'available'}>Available</button>
        <button onClick={() => softphone.setOffline()} disabled={agentStatus === 'offline'}>Offline</button>
      </div>

      {call ? (
        <section className={`call call-${call.state}`}>
          <div className="call-head">
            <span>{call.direction === 'inbound' ? 'Incoming' : 'Outbound'}</span>
            <span className="num">{call.phoneNumber}</span>
            {call.state === 'connected' && <Timer since={call.startedAt} />}
          </div>
          {call.attributes.customerName && <div className="who">{call.attributes.customerName} · {call.attributes.openIssues} open</div>}
          <div className="row">
            {call.state === 'incoming' && <>
              <button className="ok" onClick={() => softphone.accept()}>Accept</button>
              <button className="danger" onClick={() => softphone.reject()}>Decline</button>
            </>}
            {(call.state === 'connecting' || call.state === 'connected') && <>
              <button onClick={() => (call.muted ? softphone.unmute() : softphone.mute())}>{call.muted ? 'Unmute' : 'Mute'}</button>
              <button onClick={() => (call.onHold ? softphone.resume() : softphone.hold())}>{call.onHold ? 'Resume' : 'Hold'}</button>
              <button className="danger" onClick={() => softphone.hangUp()}>End</button>
            </>}
            {call.state === 'ended' && <button onClick={() => softphone.clearAcw()}>Close contact</button>}
          </div>
        </section>
      ) : (
        <section className="dialer">
          <input placeholder="+17815551234" value={dial} onChange={(e) => setDial(e.target.value.trim())} />
          <button disabled={!/^\+1\d{10}$/.test(dial) || agentStatus === 'init'} onClick={() => softphone.dial(dial)}>Call</button>
        </section>
      )}
    </aside>
  );
}
